const translation = {
  learnReact: 'chinese learn react',
  orders: {
    header: 'My Orders',
    toBeProcessed: 'To be processed',
    invoiced: 'Invoiced',
    allOrders: 'All Orders',
    orderDetails: 'Order details',
    orderNumber: 'Order No.',
    orderDate: 'Order Date',
    plantDetails: 'Plant details',
    plantModel: 'Plant Model',
    plantRegion: 'Plant Region',
    retailerDetails: 'Retailer details',
    retailerName: 'Retailer Name',
    retailerId: 'Retailer ID',
    mobileNumber: 'Mobile No',
    firmName: 'Firm Name',
    shippingAddress: 'Shipping Address',
    paymentDetails: 'Payment details',
    orderAmount: 'Order Amount',
    orderType: 'Order Type',
    razorpayId: 'Razorpay ID',
    WMSDetails: 'WMS details',
    createdDate: 'Created dDte',
    otherDetails: 'Other details',
    edd: 'EDD',
    fa: 'FA',
    action: 'Actions',
    uploadInvoice: 'Upload Invoice',
    invoiceNumber: 'Invoice Number',
    cancelOrder: 'Cancel Order',
    changeFa: 'Change FA',
    changeFaFull: 'Change Field Agent',
    editOrder: 'Edit Order',
    exportOrderDetails: 'Export order details',
    uploadEddDelay: 'Upload EDD delay'
  }
}

export default translation;